import {
  Accordion,
  AccordionItem,
  AccordionButton,
  AccordionPanel,
  AccordionIcon,
  Box,
} from "@chakra-ui/react";

const StyledAccordion = () => (
  <Accordion allowMultiple w="100%" mx="auto">
    <AccordionItem
      border="1px solid"
      borderColor="gray.200"
      borderRadius="lg"
      mb={4}
      overflow="hidden"
    >
      <h2>
        <AccordionButton
          _expanded={{ bg: "orange.50", color: "orange.600" }}
          py={5}
          px={6}
          _hover={{ bg: "gray.50" }}
          transition="all 0.2s"
        >
          <Box
            flex="1"
            textAlign="left"
            fontWeight="600"
            fontSize={{ base: "md", md: "lg" }}
            color="gray.800"
          >
            What services do you offer?
          </Box>
          <AccordionIcon color="orange.500" />
        </AccordionButton>
      </h2>
      <AccordionPanel
        pb={5}
        pt={2}
        px={6}
        bg="white"
        color="gray.600"
        fontSize={{ base: "sm", md: "md" }}
        lineHeight="1.7"
      >
        We offer a wide range of home repair services including plumbing,
        electrical work, carpentry, HVAC, painting, and general maintenance. Our
        skilled professionals are ready to help with any project.
      </AccordionPanel>
    </AccordionItem>

    <AccordionItem
      border="1px solid"
      borderColor="gray.200"
      borderRadius="lg"
      mb={4}
      overflow="hidden"
    >
      <h2>
        <AccordionButton
          _expanded={{ bg: "orange.50", color: "orange.600" }}
          py={5}
          px={6}
          _hover={{ bg: "gray.50" }}
          transition="all 0.2s"
        >
          <Box
            flex="1"
            textAlign="left"
            fontWeight="600"
            fontSize={{ base: "md", md: "lg" }}
            color="gray.800"
          >
            What are your operating hours?
          </Box>
          <AccordionIcon color="orange.500" />
        </AccordionButton>
      </h2>
      <AccordionPanel
        pb={5}
        pt={2}
        px={6}
        bg="white"
        color="gray.600"
        fontSize={{ base: "sm", md: "md" }}
        lineHeight="1.7"
      >
        We operate 24/7, however our vendors may have their own working hours.
        Please check the vendor profiles for specific availability.
      </AccordionPanel>
    </AccordionItem>

    <AccordionItem
      border="1px solid"
      borderColor="gray.200"
      borderRadius="lg"
      mb={4}
      overflow="hidden"
    >
      <h2>
        <AccordionButton
          _expanded={{ bg: "orange.50", color: "orange.600" }}
          py={5}
          px={6}
          _hover={{ bg: "gray.50" }}
          transition="all 0.2s"
        >
          <Box
            flex="1"
            textAlign="left"
            fontWeight="600"
            fontSize={{ base: "md", md: "lg" }}
            color="gray.800"
          >
            How do I schedule a service?
          </Box>
          <AccordionIcon color="orange.500" />
        </AccordionButton>
      </h2>
      <AccordionPanel
        pb={5}
        pt={2}
        px={6}
        bg="white"
        color="gray.600"
        fontSize={{ base: "sm", md: "md" }}
        lineHeight="1.7"
      >
        You can schedule a service through our website by selecting your desired
        service category and contacting the vendor directly.
      </AccordionPanel>
    </AccordionItem>
  </Accordion>
);

export default StyledAccordion;
